import { injectAPISession } from '@monofe/apiservice';
import { ILanguageSelectControllerRenderResult, IRouteLanguageSelectArguments } from './interface';

function CanRender(
    route: IRouteLanguageSelectArguments,
): Promise<ILanguageSelectControllerRenderResult> {
    return new Promise(async function (resolve, reject) {
        try {
            const workspace = await injectAPISession().open(route.sessionName);

            const db = await workspace.db.open();

            const languages = await db.all('ILanguageDto');

            const hasMultipleLanguages = languages.length > 1;

            let result: ILanguageSelectControllerRenderResult = {
                hasEnoughDataToRender: hasMultipleLanguages,
            };

            if (languages.length <= 0) {
                throw Error('No languages found, unable to launch language-select, or tour-select');
            }

            if (!result.hasEnoughDataToRender) {
                result = {
                    ...result,
                    suggestedAlternativeRoute: 'TourSelect',
                    additionalRouteDataNeeded: {
                        languageId: languages[0].id,
                    },
                };
            }

            db.close();

            resolve(result);
        } catch (error) {
            reject(error);
        }
    });
}

export default CanRender;
